import React from 'react';
import PropTypes from 'prop-types';

import Styles from './Slider.styles';

export const SliderRail = ({
  getRailProps,
}) => (
  <>
    <div className={Styles['rail-inner']} />
    <div
      className={Styles['rail-outer']}
      {...getRailProps()}
    />
  </>
);

SliderRail.propTypes = {
  getRailProps: PropTypes.func.isRequired,
};

export default SliderRail;
